import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'
import RequesterData from '@/types/RequesterData'
import ProjectData from '@/types/ProjectData'
import TermostatFilterCriteria from '@/types/TermostatFilterCriteria'
import TermostatProductLists from '@/types/TermostatProductLists'
import SelectedTermostatProducts from '@/types/SelectedTermostatProducts'
import RoomData from '@/types/RoomData'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    requester: new RequesterData(),
    projectData: new ProjectData(),
    roomsData: [] as RoomData[],
    termostatFilterCriteria: new TermostatFilterCriteria(),
    termostatProductLists: new TermostatProductLists(),
    selectedTermostatProducts: new SelectedTermostatProducts(),
    quote: {} as object,
    formValidity: {
      requesterForm: false,
      projectForm: false,
      roomsForm: false
    }
  },
  getters: {
    getField,
    getAllDataAsJson (state) {
      let csrfToken = (state.quote as any)?.token //eslint-disable-line
      if (csrfToken) {
        const csrfName = Object.keys(csrfToken)[0]
        const csrfVal = csrfToken[csrfName]
        csrfToken = ',"' + csrfName + '": "' + csrfVal + '"'
      } else {
        csrfToken = ''
      }

      return '{' +
      '"requesterData":' + JSON.stringify(state.requester, state.requester.replacer) + ',' +
      '"projectData":' + JSON.stringify(state.projectData, state.projectData.replacer) + ',' +
      '"selectedTermostatProducts":' + JSON.stringify(state.selectedTermostatProducts) + ',' +
      '"roomsData":' + JSON.stringify(state.roomsData, state.roomsData[0]?.replacer) + //eslint-disable-line
      csrfToken +
      '}'
    },
    getTermostatFilterCriteriaAsObj (state) {
      const result: Record<string, any> = {
        termostatFilterCriteria: state.termostatFilterCriteria
      }

      const csrfToken = (state.quote as any)?.token
      if (csrfToken) {
        const csrfName = Object.keys(csrfToken)[0]
        const csrfVal = csrfToken[csrfName]
        result[csrfName] = csrfVal
      }

      return result
    }
  },

  mutations: {
    addRoom: (state, roomData: RoomData) => { state.roomsData.push(roomData) },
    removeRoom: (state, index: number) => { state.roomsData.splice(index, 1) },
    setRoomProperty: (state, data: any) => { //eslint-disable-line
      state.roomsData.forEach((room: RoomData) => {
        (room as any)[data.type] = (data.selected.find((selectedRoom: RoomData) => selectedRoom.name === room.name) !== undefined) //eslint-disable-line
      })
    },
    setQuote: (state, quoteData) => { state.quote = quoteData },
    resetAll: (state) => {
      state.requester = new RequesterData()
      state.projectData = new ProjectData()
      state.termostatFilterCriteria = new TermostatFilterCriteria()
      state.termostatProductLists = new TermostatProductLists()
      state.selectedTermostatProducts = new SelectedTermostatProducts()
      state.roomsData = []
      state.quote = {}
      state.formValidity.requesterForm = false
      state.formValidity.projectForm = false
      state.formValidity.roomsForm = false
    },
    setTermostatProductLists: (state, productLists) => {
      state.termostatProductLists = {
        pro2: productLists.pro2 || [],
        tech: productLists.tech || [],
        heatmiser: productLists.heatmiser || [],
        techAccessory: productLists.techAccessory || [],
        techWirelessAccessory: productLists.techWirelessAccessory || []
      }
    },
    updateField
  },
  actions: {
  }
})
